export default __webpack_public_path__ + "static/media/Mock2.5c534682.png";